import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import logo from "../assets/images/newlogo.png"
import { FaTiktok } from 'react-icons/fa';
import { BiUpArrowAlt } from 'react-icons/bi';

export default function Footer() {
    // const [showButton, setShowButton] = useState(false);
    const handleScroll = () => {
        if (window.scrollY > 200) { // Yahan par aap scroll ke hisab se threshold set kar sakte hain

        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scrolling ke liye
        });
    };

    return (
        <div>
            <footer className="section  bg-footer">
                <div className="container">
                    <div className="row g-sm-4">
                        {/* <div className="col-lg-12">
                            <div className="mb-3 mb-sm-0">
                                <img
                                    src={logo}
                                    className="logo-dark"
                                    alt=""
                                    height={22}
                                />
                            </div>
                        </div> */}
                        <div className="col-lg-3 col-md-4 col-6">
                            <img
                                src={logo}
                                className="logo-dark"
                                alt=""
                                style={{ width: "70%" }}
                            />
                            <ul className="list-unstyled footer-link mt-3 mb-0 fs-14">
                                <li>
                                    <span onClick={scrollToTop}><Link to="#" className='links mx-1'>Return to Top </Link>< BiUpArrowAlt color='fc4a1a' size={20} /></span>
                                </li>
                            </ul>
                        </div>
                        {/* End col */}
                        <div className="col-lg-3 col-md-4 col-6">
                            <h6 className="text-uppercase fw-semibold social">Social</h6>
                            <ul className="list-unstyled footer-link mt-3 mb-0 fs-14">
                                <li>
                                    <span >< FaTiktok color='fc4a1a' /><Link to="#" className='links mx-1'>Tiktok</Link></span>
                                </li>
                            </ul>
                        </div>
                        {/* End col */}
                        <div className="col-lg-3 col-md-4 col-6 d-none d-sm-block">
                            <h6 className="text-uppercase fw-semibold social">Quick links</h6>
                            <ul className="list-unstyled footer-link mt-3 mb-0 fs-14">
                                <li>
                                    <Link to="/" className='links'>Home</Link>
                                </li>
                                <li>
                                    <Link to="/Review" className='links'>Reviews</Link>
                                </li>
                                <li>
                                    <Link to="/HowitsWork" className='links'>How It Works</Link>
                                </li>

                            </ul>
                        </div>
                        {/* End col */}
                        <div className="col-lg-3 col-10">
                            <h6 className="text-uppercase fw-semibold social">
                                Legal
                            </h6>
                            <p className="mt-md-3 pt-3 pt-md-2 links">
                                Terms & Conditions Privacy Policy
                            </p>
                            {/* <div className="mt-md-4 mt-3">
                                <ul className="list-inline footer-social mb-0">
                                    <li className="list-inline-item">
                                        <Link to="#" className="rounded">
                                            <i className="mdi mdi-facebook text-dark" />
                                        </Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="#" className="rounded">
                                            <i className="mdi mdi-linkedin text-dark" />
                                        </Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="#" className="rounded">
                                            <i className="mdi mdi-pinterest text-dark" />
                                        </Link>
                                    </li>
                                    <li className="list-inline-item">
                                        <Link to="#" className="rounded">
                                            <i className="mdi mdi-twitter text-dark" />
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
                    {/* End row */}
                </div>
                {/* End container */}
            </footer>

            <div className=" pt-3 pb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <p className="mb-0 copyright1">© 2023 <spna className="">THENEXTPHOTO.COM </spna>All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}